"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameVars_1 = require("./../GameVars");
var BoardManager_1 = require("./BoardManager");
var GameConstants_1 = require("../GameConstants");
var ConnectionManager_1 = require("../ConnectionManager");
var LocalServer_1 = require("../LocalServer");
var MenuLayer = /** @class */ (function (_super) {
    __extends(MenuLayer, _super);
    function MenuLayer(game) {
        var _this = _super.call(this, game, null, "menu-layer") || this;
        var bck = new Phaser.Sprite(_this.game, 0, 0, _this.game.cache.getBitmapData(GameConstants_1.GameConstants.BLACK_SQUARE));
        bck.scale.set(GameConstants_1.GameConstants.GAME_WIDTH / GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.GAME_HEIGHT / GameConstants_1.GameConstants.BITMAP_SIZE);
        bck.alpha = .75;
        bck.inputEnabled = true;
        bck.events.onInputDown.add(_this.bckDown, _this);
        _this.add(bck);
        var midContainer = new Phaser.Group(_this.game);
        midContainer.position.set(GameConstants_1.GameConstants.GAME_WIDTH / 2, GameConstants_1.GameConstants.GAME_HEIGHT / 2);
        midContainer.scale.y = GameVars_1.GameVars.scaleY;
        _this.add(midContainer);
        var graphic = new Phaser.Graphics(_this.game);
        graphic.beginFill(0x28303B, .8);
        graphic.lineStyle(5, 0xFFFFFF, 1);
        graphic.drawRoundedRect(-200, -240, 400, 500, 20);
        graphic.endFill();
        midContainer.add(graphic);
        var title = new Phaser.Text(_this.game, 0, -150, "PAUSE", { font: "70px Eczar", fill: "#fff17f ", align: "center" });
        title.anchor.set(.5);
        title.strokeThickness = 8;
        title.addStrokeColor("#FFFFFF", 0);
        midContainer.add(title);
        var grd = title.context.createLinearGradient(0, 0, 0, title.height);
        grd.addColorStop(0, "#00BDFF");
        grd.addColorStop(1, "#1262B5");
        title.fill = grd;
        var homeButton = new Phaser.Button(_this.game, 0, 0, "texture_atlas_1", _this.onClickHome, _this);
        homeButton.setFrames("btn_home", "btn_home", "btn_home");
        homeButton.anchor.set(.5);
        homeButton.input.pixelPerfectOver = true;
        homeButton.forceOut = true;
        midContainer.add(homeButton);
        var replayButton = new Phaser.Button(_this.game, 0, 150, "texture_atlas_1", _this.onClickRematch, _this);
        replayButton.setFrames("btn_replay", "btn_replay", "btn_replay");
        replayButton.anchor.set(.5);
        replayButton.input.pixelPerfectOver = true;
        replayButton.forceOut = true;
        midContainer.add(replayButton);
        var closeButton = new Phaser.Button(_this.game, 200, -240, "texture_atlas_1", _this.onClickClose, _this);
        closeButton.setFrames("btn_close", "btn_close", "btn_close");
        closeButton.anchor.set(.5);
        closeButton.input.pixelPerfectOver = true;
        closeButton.forceOut = true;
        midContainer.add(closeButton);
        return _this;
    }
    MenuLayer.prototype.onClickRematch = function () {
        gamezop.setState({
            state: "over",
            score: GameVars_1.GameVars.points,
            metadata: oMetaManager.meta
        });
        if (GameVars_1.GameVars.gzpGameMode !== "casual") {
            ConnectionManager_1.ConnectionManager.socket.emit("end_game", { id: GameVars_1.GameVars.initialID, leave: -1 });
            ConnectionManager_1.ConnectionManager.socket.disconnect();
        }
        else {
            LocalServer_1.LocalServer.endGame(-1);
        }
        this.game.state.start("BoardState", true, false);
        GameVars_1.GameVars.paused = false;
    };
    MenuLayer.prototype.onClickHome = function () {
        gamezop.setState({
            state: "over",
            score: GameVars_1.GameVars.points,
            metadata: oMetaManager.meta
        });
        if (GameVars_1.GameVars.gzpGameMode !== "casual") {
            ConnectionManager_1.ConnectionManager.socket.emit("end_game", { id: GameVars_1.GameVars.initialID, leave: -1 });
            ConnectionManager_1.ConnectionManager.socket.disconnect();
        }
        else {
            LocalServer_1.LocalServer.endGame(-1);
        }
        this.game.state.start("SplashState", true, false);
        GameVars_1.GameVars.paused = false;
        gamezop.isGamePaused = false;
    };
    MenuLayer.prototype.onClickClose = function () {
        BoardManager_1.BoardManager.currentInstance.hideMenuLayer();
        GameVars_1.GameVars.paused = false;
        gamezop.isGamePaused = false;
    };
    MenuLayer.prototype.bckDown = function () {
        // 
    };
    return MenuLayer;
}(Phaser.Group));
exports.MenuLayer = MenuLayer;
